import React from 'react';

/** Raster wordmark — `public/images/orivonai-logo.png` (1024×201, transparent, Beta in artwork). */
const NATURAL_W = 1024;
const NATURAL_H = 201;

/**
 * Full OrivonAI horizontal logo. Height drives scale; width follows aspect ratio.
 */
export default function Logo({ height = 38, 'aria-label': ariaLabel = 'OrivonAI' }) {
  const h = typeof height === 'number' ? height : 38;
  const w = (h * NATURAL_W) / NATURAL_H;

  return (
    <img
      src="/images/orivonai-logo.png"
      alt={ariaLabel}
      width={Math.round(w)}
      height={Math.round(h)}
      style={{
        display: 'block',
        height: h,
        width: 'auto',
        maxWidth: '100%',
      }}
      draggable={false}
    />
  );
}
